import GlobalBankPanel from './GlobalBankPanel';
import PerUserBankPanel from './PerUserBankPanel';
import PerCountryBankPanel from './PerCountryBankPanel';
import CryptoWalletsPanel from './CryptoWalletsPanel';
import PaymentLinksPanel from './PaymentLinksPanel';
import { KycConfigPanel } from './KycPluginConfig';
import CreditSystemPanel from './CreditSystemPanel';
import EmailTemplatesPanel from './EmailTemplatesPanel.jsx';
import PagesPlugin from './PagesPlugin'; 

export const PLUGIN_REGISTRY = {
  bank_transfer_global: {
    component: GlobalBankPanel,
    dataKey: 'bankAccounts',
    filterData: (data) => data.filter(a => a.plugin_type === 'global'),
    fullPage: false, // ← Stays in drawer
  },
  bank_transfer_per_user: {
    component: PerUserBankPanel,
    dataKey: 'bankAccounts',
    filterData: (data) => data.filter(a => a.plugin_type === 'per_user'),
    fullPage: false, // ← Stays in drawer
  },
  bank_transfer_per_country: {
    component: PerCountryBankPanel,
    dataKey: 'bankAccounts',
    filterData: (data) => data.filter(a => a.plugin_type === 'per_country'),
    fullPage: false, // ← Stays in drawer
  },
  crypto_payments: {
    component: CryptoWalletsPanel,
    dataKey: 'cryptoWallets',
    fullPage: false, // ← Stays in drawer
  },
  payment_links: {
    component: PaymentLinksPanel,
    dataKey: 'paymentLinks',
    fullPage: false, // ← Stays in drawer
  },
  kyc_verification: {
    component: KycConfigPanel,
    dataKey: 'kycConfig',
    requiresStats: true,
    fullPage: true, // ✅ Opens full page
  },
  credits: {
    component: CreditSystemPanel,
    dataKey: 'credits',
    fullPage: true, // ✅ Opens full page
  },
  email_templates: {
    component: EmailTemplatesPanel,
    dataKey: null,
    fullPage: true, // ✅ Opens full page
  },
  pages: {
  component: PagesPlugin,
  dataKey: null,
  fullPage: true,
},
};

export function getPluginConfig(pluginKey) { 
  return PLUGIN_REGISTRY[pluginKey] || null; 
}

export function isPluginRegistered(pluginKey) { 
  return pluginKey in PLUGIN_REGISTRY; 
}

export function getRegisteredPluginKeys() { 
  return Object.keys(PLUGIN_REGISTRY); 
}